import { Page } from '../../..'
import { defineMessages, useIntl } from 'react-intl'
import { Heading } from '@homebotapp/hb-react-component-catalog'
import { SlideOnMount } from '../../../shared/Animations'
import { OverlayQuestionsFooter } from '../../../shared/Routing'
import { CUSTOMER_MESSAGES } from '../../../../constants/customerMessages'
import { PmiProvidedModuleInfoMessages } from './PmiProvidedModuleInfoMessages'

export const MSG = defineMessages({
  heading: {
    id: 'PMI.panel.header',
    defaultMessage: 'How can you remove it faster?'
  },
  subHeading: {
    id: 'PMI.panel.subheader',
    defaultMessage: 'There are a few ways to accelerate this.'
  }
})

export const PmiProvidedModuleLearnMorePanel = () => {
  const intl = useIntl()

  return (
    <Page>
      <Page.Body>
        <SlideOnMount>
          <Heading size='xs' as='h2' variant='eyebrow' color='neutral-700'>
            {intl.formatMessage(MSG.heading)}
          </Heading>
          <Heading as='h3' marginBottom='4' fontWeight='semibold' size='sm'>
            {intl.formatMessage(MSG.subHeading)}
          </Heading>
        </SlideOnMount>
        <SlideOnMount>
          <PmiProvidedModuleInfoMessages />
        </SlideOnMount>
        <Page.Disclaimer />
      </Page.Body>
      <Page.Footer>
        <SlideOnMount>
          <OverlayQuestionsFooter
            topic={CUSTOMER_MESSAGES.MORTGAGE_INSURANCE.topic}
            topicKey={CUSTOMER_MESSAGES.MORTGAGE_INSURANCE.topicKey}
            questions={[CUSTOMER_MESSAGES.MORTGAGE_INSURANCE.secondaryMessage]}
            placeholder
            disableCospo
          />
        </SlideOnMount>
      </Page.Footer>
    </Page>
  )
}
